import React, { useContext, useState } from 'react';

import TemplatesWizardContext from '../../../TemplatesWizardContext';

import createSurveyTemplateEvent from '../../../../../helpers/eventTracking/createSurveyTemplateEvent';

import { USEBERRY_INTEGRATION_LINK } from '../../../../../helpers/constants';

import arrow from '../../../../../../../../../assets/img/templateswizard/arrow.svg';
import iconInfo from '../../../../../../../../../assets/img/templateswizard/icon_info.svg';
import useberryConnectPoster from '../../../../../../../../../assets/img/templateswizard/useberry_connect_poster.png';

import styles from './ConnectUseberry.module.css';

export default function ConnectUseberry() {
  const {
    goToPreviousStep,
    setWizardHidden,
    strings,
    actions,
    steps
  } = useContext(TemplatesWizardContext);
  const [linkCopied, setLinkCopied] = useState(false);

  const copyLinkToClipboard = () => {
    const dummy = document.createElement('input');
    document.body.appendChild(dummy);
    dummy.setAttribute('id', 'integrationurl');
    document.getElementById('integrationurl').value = USEBERRY_INTEGRATION_LINK;
    dummy.select();
    document.execCommand('copy');
    document.body.removeChild(dummy);
    setLinkCopied(true);
  };

  const onNextClick = () => {
    actions.templateWizardToSurvey(steps);
    setWizardHidden(true);
    createSurveyTemplateEvent(steps);
  };

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        {strings.CONNECT_BUFFL_AND_USEBERRY_PLATFORMS}
      </div>
      <div className={styles.subTitle}>
        {strings.ALMOST_DONE_PASTE_THE_LINK_BELOW}
      </div>
      <div className={styles.connectImageContainer}>
        <video
          autoPlay
          muted
          loop
          playsInline
          poster={useberryConnectPoster}
          style={{
            height: '180px',
            width: 'auto',
            maxWidth: '100%',
            objectFit: 'contain',
            display: 'block'
          }}
        >
          <source
            src="https://bufflprodstorage.blob.core.windows.net/clients/b706e1a0-9a87-11f1-86bc-8d4d40badcb5.mp4"
            type="video/mp4"
          />
        </video>
      </div>
      <div className={styles.linkSection}>
        <div className={styles.linkLabel}>{strings.YOUR_INTEGRATION_LINK}</div>
        <div className={styles.linkContainer}>
          <div className={styles.link}>{USEBERRY_INTEGRATION_LINK}</div>
          <div
            className={
              linkCopied
                ? `${styles.copyLinkButton} ${styles.copied}`
                : styles.copyLinkButton
            }
            onClick={copyLinkToClipboard}
            role="presentation"
          >
            <svg
              className={styles.copyIcon}
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <rect x="9" y="9" width="12" height="12" rx="2" ry="2" />
              <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
            </svg>
            {linkCopied ? strings.COPIED : strings.COPY_LINK}
          </div>
        </div>
        <div className={styles.warningContainer}>
          <img src={iconInfo} className={styles.warningIcon} alt="Icon info" />
          {strings.MAKE_SURE_TO_PASTE_THIS_LINK}
        </div>
      </div>
      <div className={styles.footerContainer}>
        <div
          className={styles.previousButton}
          onClick={goToPreviousStep}
          role="presentation"
        >
          <img src={arrow} alt="Left arrow" />
          {strings.PREVIOUS}
        </div>
        <div
          className={`${styles.nextButton} builder-wizard-template-next-button`}
          onClick={onNextClick}
          role="presentation"
        >
          {strings.NEXT}
          <img src={arrow} alt="Right arrow" />
        </div>
      </div>
    </div>
  );
}
